import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ModalLegalEntitySubClientComponent } from '../../customer/modal_subclient/modal-legal-entity-subclient/modal-legal-entity-subclient.component'
import { ModalConsultantClientComponent } from '../../person/modal-consultant-client/modal-consultant-client.component'
import { ModalEmployeeConsultantComponent } from '../../employee/modal-employee-consultant/modal-employee-consultant.component'
import { ItemProposalCreateComponent } from '../item-proposal-create/item-proposal-create.component'
import { convertCurrency } from '../../../shared/utils/utils'
import moment from 'moment'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { ItemProposalEditComponent } from '../item-proposal-edit/item-proposal-edit.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { ResponsibleService } from '../../../core/services/person/responsible/responsible.service'
import { ModalPurchasesEmailComponent } from '../../purchases/modal-purchases-email/modal-purchases-email.component'
import { ServiceAdditionalProposalEditComponent } from '../../service/service-additional-proposal-edit/service-additional-proposal-edit.component'
import { AddressClientEditComponent } from '../../address/address-client-edit/address-client-edit.component'
import { JsonPipe } from '@angular/common'
import { ReasonService } from '../../../core/services/reason/reason/reason.service'

@Component({
  selector: 'proposal-client-edit',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    ItemProposalCreateComponent,
    IntegerInputDirective,
    ItemProposalEditComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgxMaskDirective,
    ServiceAdditionalProposalEditComponent,
    AddressClientEditComponent,
    JsonPipe,
  ],
  templateUrl: './proposal-client-edit.component.html',
  styleUrl: './proposal-client-edit.component.scss',
  providers: [
    ProposalClientService,
    ProposalStatusService,
    PaymentMethodsService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ProposalClientEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private proposalStatusService: ProposalStatusService,
    private paymentMethodsService: PaymentMethodsService,
    private reasonService: ReasonService,
    private responsibleService: ResponsibleService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ProposalClientEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data) {
      this.item = { user: true, data: data }
      this.propostaId = data.id
      this.statusId = data.statusPropostaId
    }
  }
  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  @Output() responseEdit = new EventEmitter()

  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  idClient: number = -1
  propostaId: number = -1
  statusId: number = -1

  ListProposalStatus: any[] = []
  ListPaymentMethods: any[] = []
  ListResponsible: any[] = []

  ListItemsProposal: any[] = []

  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}
  reason: any = {}

  ngOnInit(): void {
    this.getStatusProposal()
    this.createForm()
    if (this.statusId == 5) {
      this.getReason()
    }
    this.blockForm()
  }

  blockForm() {
    if (
      this.statusId == 1 ||
      this.statusId == 5 ||
      this.statusId == 6 ||
      this.statusId == 9
    ) {
      this.form.disable()
    } else {
      this.form.enable()
      this.form.get('client')!.disable()
      this.form.get('subClient')!.disable()
      this.form.get('statusProposal')!.disable()
      this.form.get('grandTotal')!.disable()
      this.form.get('tgCod')?.disable()
      this.form.get('dateEmission')?.disable()
    }
  }

  getReason() {
    this.reasonService.getReasonProposalId(this.propostaId).subscribe({
      next: (response: ResponseRequestModel) => {
        this.reason = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getStatusProposal() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListProposalStatus = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getPaymentMethod(id: number) {
    this.ListPaymentMethods = []
    this.paymentMethodsService.listPaymentMethodsByPerson(id).subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListPaymentMethods = response.data
        if (
          this.statusId != 1 &&
          this.statusId != 5 &&
          this.statusId != 6 &&
          this.statusId != 9
        ) {
          this.form.get('paymentMethod')!.enable()
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        if (
          this.statusId != 1 &&
          this.statusId != 5 &&
          this.statusId != 6 &&
          this.statusId != 9
        ) {
          this.form.get('paymentMethod')!.enable()
        }
      },
    })
  }

  // getResponsible(id: number) {
  //   this.ListResponsible = []
  //   this.responsibleService.listResponsibleByPerson(id).subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.ListResponsible = response.data
  //       this.form.get('responsible')!.enable()
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {
  //       this.form.get('responsible')!.enable()
  //     },
  //   })
  // }

  editProposalClient() {
    this.loading = true
    const model = this.createModel()
    this.proposalClientService.editProposalClient(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.refreshProposal('')
        // this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    console.log('this.consultantClientSelected', this.consultantClientSelected)
    return {
      id: this.item.data.id,
      clienteId: this.item.data.clienteId,
      subClienteId: this.item.data.subClienteId ?? 0,
      // statusPropostaId: this.item.statusPropostaId,
      statusPropostaId: this.statusId,
      consultorId: this.consultantClientSelected.consultorId ?? 0,
      consultorComercialId: this.employeeConsultantSelected.id ?? 0,
      nomeEvento: this.form.get('eventName')?.value ?? '',
      formaPagamentoId: this.form.get('paymentMethod')?.value ?? '',
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      quantidadePassageiros:
        parseInt(this.form.get('numPassengers')?.value) ?? 0,

      solicitante: this.form.get('requesterName')!.value,
      solicitanteEmail: this.form.get('requesterEmail')!.value,
      solicitanteTelefone: this.form.get('requesterPhone')!.value,
    }
  }

  fillForm(item: any) {
    this.clientSelected = {
      id: item.clienteId,
      nome: item.nomeCliente,
    }
    if (item.subClienteId != 0) {
      this.subClientSelected = {
        id: item.subClienteId,
        nome: item.nomeSubCliente,
      }
    }
    if (item.consultorId != 0) {
      this.consultantClientSelected = {
        id: item.consultorId,
        consultorId: item.consultorId,
        nome: item.nomeConsultor,
      }
    }
    if (item.consultorComercialId != 0) {
      this.employeeConsultantSelected = {
        id: item.consultorComercialId,
        nome: item.consultorComercial,
      }
    }
    // this.form.get('statusProposal')!.setValue(item.statusPropostaId)
    this.form.get('statusProposal')!.setValue(item.statusPropostaDescricao)
    this.form.get('dateEmission')!.setValue(item.dataCriacao)
    this.form.get('eventName')!.setValue(item.nomeEvento)
    this.form.get('client')!.setValue(this.clientSelected.nome)
    this.form.get('client')!.disable()
    this.form.get('subClient')!.setValue(this.subClientSelected.nome ?? '')
    this.form.get('subClient')!.disable()
    this.form
      .get('consultant')!
      .setValue(this.consultantClientSelected.nome ?? '')
    this.form
      .get('employeeConsultant')!
      .setValue(this.employeeConsultantSelected.nome ?? '')
    // this.form.get('serviceFee')!.setValue(convertCurrency(item.taxa))
    this.form.get('grandTotal')!.setValue(convertCurrency(item.valorTotal))
    this.form.get('numPassengers')!.setValue(item.quantidadePassageiros)
    this.form.get('paymentMethod')!.setValue(item.formaPagamentoId)
    this.form
      .get('dateStart')!
      .setValue(moment(item.dataInicio, 'DD/MM/YYYY').toDate())
    this.form
      .get('dateEnd')!
      .setValue(moment(item.dataFim, 'DD/MM/YYYY').toDate())

    this.form.get('requesterName')!.setValue(item.solicitante)
    this.form.get('requesterEmail')!.setValue(item.solicitanteEmail)
    this.form.get('requesterPhone')!.setValue(item.solicitanteTelefone)

    this.form.get('tgCod')!.setValue(item.codigoTg)

    this.form.get('statusProposal')!.disable()
    this.form.get('grandTotal')!.disable()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusProposal: ['', [Validators.required]],
      eventName: ['', [Validators.required]],
      dateEmission: ['', [Validators.required]],
      dateStart: ['', [Validators.required]],
      // timeStart: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      // timeEnd: ['', [Validators.required]],
      client: ['', [Validators.required]],
      subClient: [''],
      consultant: ['', [Validators.required]],
      employeeConsultant: [''],
      grandTotal: [convertCurrency(0)],
      numPassengers: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      requesterName: ['', [Validators.required]],
      requesterEmail: ['', [Validators.required]],
      requesterPhone: ['', [Validators.required]],
      // responsible: [''],
      tgCod: [''],
    })
    this.form.get('tgCod')?.disable()
    this.form.get('dateEmission')?.disable()

    if (this.item.data) {
      this.getPaymentMethod(
        this.item.data.subClienteId != (0 || null)
          ? this.item.data.subClientePessoaId
          : this.item.data.clientePessoaId,
      )
      // this.getResponsible(
      //   this.item.data.subClienteId != (0 || null)
      //     ? this.item.data.subClientePessoaId
      //     : this.item.data.clientePessoaId,
      // )
      this.fillForm(this.item.data)
    }
  }

  addConsultantClient() {
    let idClient =
      this.subClientSelected && this.subClientSelected.id
        ? this.subClientSelected.id
        : this.clientSelected.id
    const dialogRef = this.dialog.open(ModalConsultantClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: idClient,
        // item: {
        //   id: this.consultantClientSelected.consultorId,
        //   description: this.consultantClientSelected,
        // },
        item: this.consultantClientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (
            response.selection.consultorId !=
            this.consultantClientSelected.consultorId
          ) {
            this.consultantClientSelected = response.selection
            this.form
              .get('consultant')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterName')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterEmail')!
              .setValue(this.consultantClientSelected.email)
            this.form
              .get('requesterPhone')!
              .setValue(this.consultantClientSelected.telefone)
          }
        } else {
          this.clearItem(['consultant'])
        }
        // if (response.remove == false) {
        //   if (
        //     response.selection.consultorId !=
        //     this.consultantClientSelected.consultorId
        //   ) {
        //     this.consultantClientSelected = response.selection
        //     this.form
        //       .get('consultant')!
        //       .setValue(this.consultantClientSelected.nome)
        //   }
        // } else {
        //   this.clearItem(['consultant'])
        // }
      }
    })
  }

  addEmployeeConsultant() {
    const dialogRef = this.dialog.open(ModalEmployeeConsultantComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.employeeConsultantSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.form
            .get('employeeConsultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearItem(['employeeConsultant'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
    // if (items.includes('responsible')) {
    //   this.ListResponsible = []
    //   this.form.get('responsible')!.setValue('')
    // }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  // fillResponsible() {
  //   if (this.form.get('responsible')!.value != '') {
  //     let responsible = this.form.get('responsible')!.value
  //
  //     this.form.get('requesterName')!.setValue(responsible.nome ?? '')
  //     this.form.get('requesterPhone')!.setValue(responsible.telefone ?? '')
  //     this.form.get('requesterEmail')!.setValue(responsible.email ?? '')
  //
  //     this.form.get('responsible')!.setValue('')
  //   }
  // }

  modalPurchases() {
    const dialogRef = this.dialog.open(ModalPurchasesEmailComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '600px',
      minWidth: '600px',
      data: {
        propostaId: this.propostaId,
      },
    })
  }

  refreshProposal(event: any) {
    console.log('refreshProposal', event)
    this.responseEdit.emit(true)
    this.proposalClientService
      .getProposalClientbyId(this.item.data.id)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          if (response.data) {
            this.getPaymentMethod(
              response.data.subClienteId != (0 || null)
                ? response.data.subClientePessoaId
                : response.data.clientePessoaId,
            )
            // this.getResponsible(
            //   response.data.subClienteId != (0 || null)
            //     ? response.data.subClientePessoaId
            //     : response.data.clientePessoaId,
            // )
            this.fillForm(response.data)
          }
        },
        error: (err: ErrorRequestModel) => {},
        complete: () => {},
      })
  }
}
